const form = document.getElementById("custom-recharge-form");
const quantityInput = document.getElementById("recharge-quantity");
const quantityElement = document.getElementById("custom-recharge-form-quantity");
const summaryElement = document.getElementById("custom-recharge-form-summary");
const priceElement = document.getElementById("custom-recharge-form-price");
const save_text = document.getElementById("custom-recharge-form-saving")

let config = { childList: true };
let radioContainer = document.getElementById("custom-recharge-form-radios");
let checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

let quantity;

const linkedProductsSelect = document.getElementById('linked-product-select');

if(quantityInput){
    quantity = parseInt(quantityInput.value);

    let targetNode = document.getElementsByClassName("recharge-subscription-widget")[0].getElementsByTagName("DIV")[0];

    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                let select = targetNode.querySelector('select[name="rc_selling_plan"]');
                if (select) {
                    let options = select.options;
                    radioContainer.innerHTML = "";
    
                    for (let i = 0; i < options.length; i++) { // Création des radio butons en fonction du select Recharge
                        let option = options[i];
    
                        let divWrapper = document.createElement("div");
                        divWrapper.className = "custom-recharge-form-radio"
    
                        let radio = document.createElement("input");
                        radio.type = "radio";
                        radio.name = "selling_plan";
                        radio.value = option.value;
                        radio.setAttribute("form", productFormId);
                        radio.id = "recharge-frequency-" + i;
                        if (i === options.length - 1)
                            radio.checked = true;
                        
                        let label = document.createElement("label");
                        label.innerHTML = option.text + ((i === options.length - 1)? ' (Standard)' : ' (Extra contrôle des odeurs)');
                        label.setAttribute("for", "recharge-frequency-" + i);
    
    
                        divWrapper.appendChild(radio);
                        divWrapper.appendChild(label);
                        radioContainer.appendChild(divWrapper);
                    }
    
                    observer.disconnect();
                }
            }
        }
    });

    observer.observe(targetNode, config);

} else if(linkedProductsSelect){
    quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
}

// Fonction pour mettre à jour les détails en fonction des inputs
function updateFormDetails() {
    const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
    let frequency = "";

    if(quantityInput){
        quantity = parseInt(quantityInput.value);
    } else if(linkedProductsSelect){
        quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
    }

    frequencyInputs.forEach((input) => {
        radio = input.querySelector('input')
        label = input.querySelector('label')
        if (radio.checked)
            frequency = label.textContent.replace('Livraison', 'delivered');
    });

    if (quantity > 1) {
        //save_text.style.display = "block";
        //priceElement.innerHTML = '<span class="compare-price">£14.70</span> £13.50 unit'
    }
    else {
        //save_text.style.display = "none";
       // priceElement.innerHTML = '13.50 unit'
    }

    const quantityText = `${quantity} Pacha bag${quantity > 1 ? 's' : ''} `;
    const summaryText = `${quantity} bag${quantity > 1 ? 's' : ''} of litter ${frequency}`;

    quantityElement.textContent = quantityText;
    summaryElement.textContent = summaryText;
}

form.addEventListener("change", updateFormDetails);

// Fonction pour mettre à jour le select Recharge en fonction du radio custom checked
function updateSelectFromRadio() {
    if(targetNode){
      let select = targetNode.querySelector('select[name="rc_selling_plan"]');
    }
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {
        select.value = checkedRadio.value;
        let changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        // Déclenche l'événement "change" sur le select pour changer l'url avec le selling_plan (comportement normal de Recharge)
        select.dispatchEvent(changeEvent);
    }
}

if(quantityInput){
  radioContainer.addEventListener("change", updateSelectFromRadio);
}

let checkoutButton = document.querySelector('[checkout-button]');

if(checkoutButton) {
    checkoutButton.addEventListener('click', goCheckout);
}

function goCheckout() {
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {

        const quantityToSubmit = linkedProductsSelect ? 1 : quantity;

        let formData = {
            'items': [{
                id: productId,
                quantity: quantityToSubmit,
                selling_plan: parseInt(checkedRadio.value)
            }]
        };

        console.log(formData);
        

        fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(response => {
            window.location.href = '/checkout';
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

class ProductSelector extends HTMLElement{
    constructor(){
        super();

        this.select = this.querySelector('select');
    }

    connectedCallback(){
        this.setProductId();

        this.select.addEventListener('change', () => {
            this.setProductId();

            const activeOption = this.select.options[this.select.selectedIndex];
            this.setActiveFormRadios(activeOption.dataset.index);
        })

    }

    setProductId(){
        productId = parseInt(this.select.value);
    }

    setActiveFormRadios(index){
        const allRadios = document.querySelectorAll('.custom-recharge-form-radios')

        allRadios.forEach(radio => {
            if(radio.dataset.index === index){
                radio.classList.remove('hidden');

                const radioInputs =  radio.querySelectorAll('input');

                radioInputs[1].checked = true;
            }
            else{
                radio.classList.add('hidden');
            }
        })
    }
}

customElements.define('product-selector', ProductSelector);

$(document).on("change", "select#linked-product-select", function(){
    var val = $("select#linked-product-select option:selected").text();
    if(val.indexOf(4) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£84.00</span> £77.00");
    }

    if(val.indexOf(5) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£105.00</span> £96.00");
    }

    if(val.indexOf(6) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£126.00</span> £115.00");
    }

    if(val.indexOf(7) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£147.00</span> £135.00");
    }

    if(val.indexOf(8) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£168.00</span> £154.00");
    }

    if(val.indexOf(9) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£189.00</span> £173.00");
    }

    if(val.indexOf(10) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£210.00</span> £193.00");
    }

    if(val.indexOf(11) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£231.00</span> £212.00");
    }

    if(val.indexOf(12) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£252.00</span> £231.00");
    }

    if(val.indexOf(24) != -1){
        $("p#custom-recharge-form-price").html("<span class='compare-price'>£504.00</span> £463.00");
    }

})